import { render, staticRenderFns } from "./KegelAbout.vue?vue&type=template&id=83c1540e&"
import script from "./KegelAbout.vue?vue&type=script&lang=js&"
export * from "./KegelAbout.vue?vue&type=script&lang=js&"
import style0 from "./KegelAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports